import Linkify from 'react-linkify';
import { replacePhoneNumbers } from './../../../../../Utilities/Autolinking';

function MessageContent(props: { messageContent: string }) {
    let messageContent = replacePhoneNumbers(props.messageContent)
    return (
        <pre style={{ whiteSpace: 'pre-wrap', fontFamily: "Inter", margin: '0px' }}>
            <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="blank" rel="noopener noreferrer" href={decoratedHref} key={key}>
                        {decoratedText.substring(0, 25)}{decoratedText.length > 25 ? "..." : ""}
                    </a>
                )}>{messageContent}</Linkify>
        </pre>
    )
}
export default MessageContent;